module.exports = __webpack_public_path__ + "static/lemonanimal2-9ad0d7011b61a1b4e3c3f6ddfd50f9aa.png";